<template>
  <header class="main-header">
    <hardware-info v-if="showHardwareInfo" @close="showHardwareInfo=false"></hardware-info>
    <el-dialog
      :append-to-body="true"
      :visible.sync="themeDialog"
      :title="$t('navigation.userMenu.themeTitle')"
    >
      <el-radio-group v-model="selectedTheme" @change="themeChanged">
        <el-radio-button label="dark">{{
          $t("navigation.userMenu.themeDark")
        }}</el-radio-button>
        <el-radio-button label="desktop">{{
          $t("navigation.userMenu.themeDesktop")
        }}</el-radio-button>
      </el-radio-group>
    </el-dialog>
    <el-dialog
      :title="$t('navigation.userMenu.headerDialog.versions')"
      :visible.sync="versionsDialogVisible"
      center
      :append-to-body="true"
    >
      <div>
        <div>
          {{
            $t("navigation.userMenu.headerDialog.generalAgentVersion")
          }}
          &mdash; {{ serversVersions.main }}
        </div>
        <div>{{ serversVersions.front }}</div>
        <br />
        <div>
          {{ $t("navigation.userMenu.headerDialog.tinyAgentsVersion") + ":" }}
        </div>
        <ul>
          <li
            v-for="(server, index) in serversVersions.tiny"
            :key="index"
            class="tiny-version"
          >
            {{ server.name }} &mdash; {{ server.vers }} <br /><span
              v-if="server.unix"
              >{{ server.unix }}</span
            ><span v-else>UNKNOWN</span>
          </li>
        </ul>
      </div>
    </el-dialog>
    <div class="header-left">
      <h2 class="main-name" :style="{ 'margin-left': titleLeftPadding }">
        {{ page_name }}
      </h2>
    </div>
    <div>
      <div class="version">1.2.0</div>
      <div class="user-right" v-if="show_usermenu">
        <el-popover placement="bottom">
          <div class="submenu">
            <b class="submenu-item text" v-if="!!getUser"
              >{{ $t("navigation.userMenu.user") }}: {{ getUser.login }}</b
            >
            <b class="submenu-item text"
              >{{ $t("navigation.userMenu.userRole") }}: {{ userRole }}</b
            >
            <div class="submenu-item vers-text">
              {{ $t("navigation.userMenu.version") }}: 1.2.0
            </div>
            <div class="submenu-item vers-text">
              {{ $t("navigation.userMenu.mainServerVersion") }}:
              {{ mainVersion }}
            </div>
            <el-link
              class="submenu-user-item"
              :underline="false"
              @click="getServersVersions"
              >{{ $t("navigation.userMenu.serversVersions") }}</el-link
            >
            <el-link
              class="submenu-user-item"
              :underline="false"
              @click="getHardwareInfo"
              v-if="getUser && +getUser.roleid <= 1 || getUser && +getUser.roletype === 1"
              >{{ $t("navigation.userMenu.hardwareInfo") }}</el-link
            >
            <el-link
              class="submenu-user-item"
              :underline="false"
              @click="clearLocalStorage"
              >{{ $t("navigation.userMenu.clearLocalStorage") }}</el-link
            >
            <el-link
              class="submenu-user-item"
              :underline="false"
              @click="backupBase"
               v-if="getUser && +getUser.roleid <= 1"
              >{{ $t("navigation.userMenu.backup") }}</el-link
            >
            <el-link
              class="submenu-user-item"
              :underline="false"
              @click="passwordChange"
              >{{ $t("navigation.userMenu.passwordChange") }}</el-link
            >
            <el-link
              class="submenu-user-item"
              :underline="false"
              @click="errorsShow"
              >{{ $t("navigation.userMenu.lastErrors") }}</el-link
            >
            <el-link
              class="submenu-user-item logout"
              :underline="false"
              @click="logOut"
              >{{ $t("navigation.userMenu.exit") }}</el-link
            >
          </div>
          <div slot="reference" class="icon">
            <i class="el-icon-user-solid icon-inside"></i
            ><i class="el-icon-arrow-down icon-arrow"></i>
          </div>
        </el-popover>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import HardwareInfo from "../../reference/HardwareInfo.vue";

export default {
  data() {
    return {
      themeDialog: false,
      selectedTheme: null,
      versionsDialogVisible: false,
      showHardwareInfo: false
    };
  },
  props: {
    page_name: String,
    show_usermenu: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    logoClick() {
      // //console.log(this.$router.currentRoute);
      if (this.$router.currentRoute.name !== "homeLink") {
        this.$router.push({ name: "homeLink" });
      }
    },
    logOut() {
      this.$store.dispatch("signOut");
    },
    getServersVersions() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getServersVersions")
        .then(() => {
          this.$store.commit("setLoading", false);
          this.versionsDialogVisible = true;
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    getHardwareInfo(){
      this.showHardwareInfo = true;
    },
    clearLocalStorage() {
      const keys = Object.keys(window.localStorage);
      for(const key of keys){ 
        if(key !== "wa-presets") window.localStorage.removeItem(key);
      }
      this.$message(
        this.$t("navigation.userMenu.headerMessages.plsRefreshPage")
      );
    },
    passwordChange() {
      this.$router.push({ name: "passwordLink" });
    },
    backupBase() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("backupBase")
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    changeTheme() {
      this.themeDialog = true;
    },
    themeChanged() {
      this.$store.commit("setTheme", this.selectedTheme);
    },
    errorsShow() {
      const h = this.$createElement;
      //console.log(this.getErrorsArray);
      let vNodesArray = [];
      // this.getErrorsArray.forEach(error => //console.log(error));
      this.getErrorsArray.forEach((error) => vNodesArray.push(h("div", error)));
      if (vNodesArray.length === 0) {
        vNodesArray = this.$t("navigation.userMenu.headerMessages.noMistakes");
      }
      this.$msgbox({
        title: this.$t("navigation.userMenu.headerMessages.lastMistakes"),
        message: h("div", vNodesArray),
        confirmButtonText: "OK",
      })
        .then(() => {})
        .catch(() => {});
    },
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getErrorsArray",
      "theme",
      "getMenu",
      "mainVersion",
      "userRole",
      "serversVersions",
    ]),
    titleLeftPadding() {
      if (this.getMenu && this.getMenu === "full") {
        return "var(--nav-left-width)";
      }
      if (this.getMenu && this.getMenu === "small") {
        return "var(--nav-left-small)";
      }
      return "";
    },
  },
  components: {
    HardwareInfo
  },
  created() {
    this.selectedTheme = this.theme;
  },
};
</script>

<style scoped>
.main-header {
  height: var(--header-height);
  display: flex;
  justify-content: space-between;
  /* background: var(--main-background); */
  background: var(--header-color);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 998;
}
.header-left {
  display: flex;
  justify-content: space-around;
  padding: 5px 3em;
}
.main-name {
  margin-bottom: 8px;
  margin-top: 5px;
  font-weight: 600;
  cursor: default;
}

.user-right {
  padding-top: 5px;
  display: flex;
  text-align: center;
  margin-right: 15px;
}

.icon {
  cursor: pointer;
  margin: 10px 10px;
}
.icon:focus {
  outline: none;
}
.icon-inside {
  background-color: var(--main-background);
  border-radius: 50%;
  /* border: 1px solid black; */
  transform: scale(2.2);
}
.icon:hover .icon-inside {
  background-color: var(--header-color);
}
.icon-arrow {
  margin-left: 15px;
}

.info-icon {
  width: 30px;
  margin-top: 4px;
  margin-right: 10px;
  cursor: pointer;
}
.submenu {
  display: flex;
  flex-direction: column;
}
.submenu-item {
  align-self: right;
  margin-right: -10px;
}
.submenu-item.vers-text {
  font-size: 0.9em;
  font-style: italic;
}
.submenu-item.first {
  margin-right: 1px;
}
.submenu-user-item {
  justify-content: flex-start;
  margin-top: 10px;
}
.submenu-user-item.logout {
  font-weight: 600;
}
.version {
  color: darkgrey;
  position: absolute;
  right: 10px;
  /* top: calc(var(--header-height) - 15px); */
  font-size: 0.7em;
}
.tiny-version {
  margin-left: 30px;
  list-style: disc;
}
</style>